import React, { createContext, useContext, useState } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("ar"); // Default language
  const [direction, setDirection] = useState("rtl"); // Default direction

  const changeLanguage = (lang) => {
    setLanguage(lang);
    setDirection(lang === "ar" ? "rtl" : "ltr");
  };

  return (
    <LanguageContext.Provider value={{ language, direction, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
